import { ComingSoonTag } from './ComingSoonTag'

export default ComingSoonTag
